import { memo } from 'react';

import { FooterMeta } from './FooterMeta';

export * from './FooterMeta';

export default memo(FooterMeta);
